<template>
  <div>
    <el-dialog
      :width="dialogWidth"
      :visible.sync="visible"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :before-close="closePopUp"
      top="0"
      @click.native.stop
    >
      <div slot="title">
        <div class="el-dialog__title">
          {{ $t('Gamification_RegionToggle_Title') }}
        </div>
        <div class="sub-title">
          {{ $t('Gamification_RegionToggle_Description') }}
        </div>
      </div>
      <div class="items-container">
        <div v-for="region in regions" :key="region.id" class="item-container">
          <div
            class="item"
            :class="{
              'active-class': activeRegions && activeRegions.includes(region.id)
            }"
            @click="toggleRegionActiveState(region.id)"
          >
            <div class="content">
              <icon class="icon" :glyph="region.continent" size="170" />
              <h3>{{ $t(RegionNameLabel[region.continent]) }}</h3>
              <p class="region-name">{{ region.name }}</p>
            </div>
            <el-switch
              :value="activeRegions.includes(region.id) ? 1 : 0"
              class="toggle-switch"
            ></el-switch>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="!activeRegions.length && type === 'inactive'"
          type="primary"
          icon="el-icon-check"
          @click="updateRegions(game.id)"
        >
          {{ $t('Gamification_RegionToggle_Save') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { RegionNameLabel } from '@/modules/gamification/enum/RegionNameEnum'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'GameRegionToggleDialog',

  props: {
    game: {
      type: Object,
      required: true
    },

    regions: {
      type: Array,
      required: true
    },

    visible: {
      type: Boolean,
      required: false
    },

    type: {
      type: String,
      required: true
    },

    activeRegionsForGame: {
      type: Array,
      required: true
    },

    activeGameId: {
      required: false
    }
  },

  data() {
    return {
      RegionNameLabel,
      activeRegions: this.activeRegionsForGame
    }
  },

  computed: {
    dialogWidth() {
      let width = 912

      const length = this.regions.length
      if (length === 1 || length === 2 || length === 4) {
        width = 632
      }

      if (length === 7 || length === 8) {
        width = 1200
      }

      if (length >= 9) {
        width = 1550
      }

      return `${width}px`
    }
  },

  methods: {
    closePopUp() {
      this.$emit('close')
    },
    toggleRegionActiveState(regionId) {
      const index = this.activeRegions.indexOf(regionId)
      if (index > -1) {
        this.activeRegions.splice(index, 1)
      } else {
        this.activeRegions.push(regionId)
      }
    },
    activateGame(gameId) {
      RestApi({
        method: 'post',
        url: `projects/${this.$route.query.project_id}/active-games`,
        data: {
          game_id: gameId,
          regions: this.activeRegions
        }
      })
        .then(async () => {
          this.$message({
            message: this.$t('Gamification_Activate_Game_Successful'),
            type: 'success'
          })
          this.closePopUp()
          await this.$store.dispatch('fetchActiveGames')
        })
        .catch(async () => {
          this.$message({
            message: this.$t('Gamification_Activate_Game_Failed'),
            type: 'error'
          })
          this.closePopUp()
          await this.$store.dispatch('fetchActiveGames')
        })
    },
    updateActiveGame() {
      RestApi({
        method: 'patch',
        url: `projects/${this.$route.query.project_id}/active-games/${this.activeGameId}`,
        data: {
          regions: this.activeRegions
        }
      })
        .then(async () => {
          this.$message({
            message: this.$t('Gamification_Region_Update_Successful'),
            type: 'success'
          })
          this.closePopUp()
          await this.$store.dispatch('fetchActiveGames')
        })
        .catch(async () => {
          this.$message({
            message: this.$t('Gamification_Activate_Game_Failed'),
            type: 'error'
          })
          this.closePopUp()
          await this.$store.dispatch('fetchActiveGames')
        })
    },
    updateRegions(gameId) {
      if (this.type === 'inactive') {
        this.activateGame(gameId)
        return
      }

      if (!this.activeRegions.length) {
        this.$emit('deactivateGame', gameId)
      } else {
        this.updateActiveGame()
      }
    }
  }
}
</script>

<style scoped>
>>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

>>> .el-dialog__body {
  overflow: auto;
}

>>> .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 20px;
}

.active-class {
  background-color: #f2f5f9;
  border: 3px solid #1d87c8;
  border-radius: 4px;
  box-sizing: border-box;
  margin: -1px;
  width: 256px !important;
  height: 252px !important;
}

.items-container {
  padding: 0 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.item-container {
  border: 1px solid #a7acba;
  border-radius: 4px;
  box-sizing: border-box;
  transition: all 0.5s;
}

.item-container:hover {
  box-shadow: rgba(67, 90, 111, 0.3) 0 0 1px,
    rgba(67, 90, 111, 0.47) 0 8px 10px -4px;
  transform: translateY(-2px);
  cursor: pointer;
}

.item {
  position: relative;
  width: 254px;
  height: 250px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.toggle-switch {
  position: absolute;
  top: 10px;
  right: 10px;
}

.icon {
  color: #1d87c8;
  margin-bottom: 10px;
}

.sub-title {
  color: #606266;
  font-size: 14px;
  padding-top: 5px;
}

.active-class {
  background-color: #f2f5f9;
  border: 3px solid #1d87c8;
  border-radius: 4px;
  box-sizing: border-box;
  margin: -1px;
  width: 256px !important;
  height: 252px !important;
}

.region-name {
  overflow: hidden;
  width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

@media screen and (max-height: 850px) {
  >>> .el-dialog__body {
    max-height: 450px;
  }
}

@media screen and (max-height: 650px) {
  >>> .el-dialog__body {
    max-height: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-dashboard/GameRegionToggleDialog.vue